import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import PromopageAction from "./page-action/PromoPageAction";

const PromoCodePageTable = lazy(
  () =>
    import("../../components/table/all-tables/promotable/PromoCodePageTable")
);
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import { commonText, promoCode } from "../../locales/en";
import ErrorBoundary from "../../components/error-boundary";
import ComponentViewFallback from "../../components/error-boundary/fallback/ComponentViewFallback";

export default function PromoCodePage() {
  return (
    <>
      <LoginAsUser />
      <TablePagesTitle mainTitle={promoCode.mainTitle} />

      <PromopageAction
        subheading={promoCode.subheading}
        allpromocodes="/admin/promo-codes"
        createpromocodes="/admin/promo-codes/create"
      />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
              <PromoCodePageTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
